import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const packages = [{
  name: 'Essential',
  duration: '60 min',
  price: '$85',
  features: ['Choice of Swedish or Deep Tissue', 'Aromatherapy enhancement', 'Hot towel finish', 'Complimentary herbal tea'],
  isPopular: false
}, {
  name: 'Premium',
  duration: '90 min',
  price: '$125',
  features: ['Any massage modality', 'Hot stone integration', 'Scalp & foot massage', 'Aromatherapy enhancement', 'Complimentary herbal tea'],
  isPopular: true
}, {
  name: 'Ultimate',
  duration: '120 min',
  price: '$175',
  features: ['Full body custom massage', 'Hot stone & aromatherapy', 'Exfoliating foot scrub', 'Extended scalp massage', 'Take-home essential oil blend'],
  isPopular: false
}];
export function Pricing() {
  return <section id="pricing" className="py-24 bg-[#111111]" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="text-center mb-16" data-id="element-171">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl text-[#F5F0EB] mb-4" data-id="element-172">
            Spa Packages
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '80px'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="h-1 bg-[#D4AF37] mx-auto mb-6" data-id="element-173" />
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="text-[#999999] max-w-2xl mx-auto text-lg" data-id="element-174">
            Choose the perfect duration for your relaxation journey.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-175">
          {packages.map((pkg, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`relative bg-[#1A1A1A] p-8 rounded-sm shadow-sm border ${pkg.isPopular ? 'border-[#D4AF37] shadow-md transform md:-translate-y-4' : 'border-[#2A2A2A]'}`} data-id="element-176">
              {pkg.isPopular && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-177">
                  <span className="bg-[#D4AF37] text-[#0A0A0A] px-4 py-1 text-xs font-bold uppercase tracking-wider rounded-sm shadow-sm" data-id="element-178">
                    Most Popular
                  </span>
                </div>}

              <div className="text-center mb-8" data-id="element-179">
                <h3 className="text-2xl text-[#F5F0EB] mb-2" data-id="element-180">{pkg.name}</h3>
                <p className="text-[#999999] font-medium uppercase tracking-wider text-sm mb-4" data-id="element-181">
                  {pkg.duration}
                </p>
                <div className="text-5xl font-serif text-[#D4AF37] mb-2" data-id="element-182">
                  {pkg.price}
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-183">
                {pkg.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-184">
                    <Check className="w-5 h-5 text-[#D4AF37] mr-3 flex-shrink-0 mt-0.5" data-id="element-185" />
                    <span className="text-[#999999] text-sm" data-id="element-186">{feature}</span>
                  </li>)}
              </ul>

              <a href="#contact" className={`block w-full text-center py-3 rounded-sm transition-colors duration-300 font-medium uppercase tracking-wider text-sm ${pkg.isPopular ? 'bg-[#D4AF37] text-[#0A0A0A] hover:bg-[#F0D060]' : 'bg-[#2A2A2A] text-[#F5F0EB] hover:bg-[#D4AF37] hover:text-[#0A0A0A]'}`} data-id="element-187">
                Select Package
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}